import { ace } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const createCallOrder =
  ({ token, url: { service: baseURL } }: IAPI) =>
    (order: ace.CreateCallOrderRequest): Promise<ace.CallOrder> =>
      send({
        baseURL,
        token,
        path: '/ace/calls/v1/orders',
        method: 'POST',
        body: order,
      });

export const getCallOrders =
  ({ token, url: { service: baseURL } }: IAPI) =>
    (): Promise<ace.FindCallOrderResponse> =>
      send({
        baseURL,
        token,
        path: '/ace/calls/v1/orders',
        method: 'GET',
      });

export const createCallRecord =
  ({ token, url: { service: baseURL } }: IAPI) =>
    (order: ace.CreateCallRecordRequest): Promise<ace.CallOrder> =>
      send({
        baseURL,
        token,
        path: '/ace/calls/v1/records',
        method: 'POST',
        body: order,
      });

export const getCallRecords =
  ({ token, url: { service: baseURL } }: IAPI) =>
    (req: ace.FindCallRecordsRequest): Promise<ace.FindCallRecordsResponse> => {
      const searchParams = new URLSearchParams();

      if (req.LoanApplicationID) {
        searchParams.append('LoanApplicationID', req.LoanApplicationID);
      }

      if (req.CustomerPhoneNumber) {
        searchParams.append('CustomerPhoneNumber', req.CustomerPhoneNumber);
      }

      return send({
        baseURL,
        token,
        path: `/ace/calls/v1/records?${searchParams}`,
        method: 'GET',
      });
    };

export const patchCallRecord =
  ({ token, url: { service: baseURL } }: IAPI) =>
    ({
      id,
      patches,
    }: {
      id: string;
      patches: ace.PatchCallRecordRequest;
    }): Promise<ace.CallRecord> =>
      send({
        baseURL,
        token,
        path: `/ace/calls/v1/records/${encodeURIComponent(id)}`,
        method: 'PATCH',
        body: patches,
      });

export const toggleIsCallRecordAnswered =
  ({ token, url: { service: baseURL } }: IAPI) =>
    ({ id }: { id: string }): Promise<ace.CallRecord> =>
      send({
        baseURL,
        token,
        path: `/ace/calls/v1/records/${encodeURIComponent(id)}/answered`,
        method: 'PATCH',
      });

export const getCallTags =
  ({ token, url: { service: baseURL } }: IAPI) =>
    (): Promise<ace.FindCallTagsResponse> =>
      send({
        baseURL,
        token,
        path: '/ace/calls/v1/tags',
        method: 'GET',
      });
